import React, { useEffect, useState } from "react"
import Banner from "../containers/banner"
import About from "../containers/about"
import Skills from "../containers/skills"
import Project from "../containers/project"
import Layout from "../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Title, Titlespan2 } from '../components/title/index';
import AfterBanner from '../containers/after-banner';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Business Transformation" body="NGT Transformation Services is made up of the best profressionals in the telecommunications industry."/>
            <AfterBanner title="Digital Transformation" subtitle="Overview" description="Whether you have an urgent need to improve financial performance or a burning desire to reinvent your business to stay ahead of the competition, only a bold, comprehensive transformation program will do so. We provide the expertise, tools, and materials you need to align your leadership on a shared vision of what the future can be and mobilize the organization to achieve it.">
                <p>Transformation spans your entire organization in the following 3 domains – people, process, and technology, to address all the changes needed to obtain the full potential. Particularly, we drive change through the front lines, with innovative solutions, rapid scaling and the skill-building required to sustain your success. We are uniquely positioned to provide the broad capabilities and expertise required to make this happen—after all, strategic transformation has been at the core of what we do for years. If your company is under performing and aspire to run in its full potential, we can guide you on a cross-functional effort that will conclude in sustained, greater performance.</p>
                <p>We help:</p>
                <ul><li>Providing digital transformation solutions for the Small and medium business and traders.</li></ul>

            </AfterBanner>
            <About width={8} title={'Business Drivers'} body={(
                <div>
                    <p className="text-white">he following table consolidates the drivers, focus area and business benefits:</p>
                    <table className="table text-white" style={{width: '100%'}}>
                        <tbody>
                            <tr>
                                <td>Increase customer demand for personalised experience</td>
                                <td>Increase sales, customer acquisition, retention and satisfaction</td>
                                <td>Improved marketing and sales effectiveness</td>
                            </tr>
                            <tr>
                                <td>Increased disruption from use of new business model</td>
                                <td>Better prediction of potential buyers and new product outcomes</td>
                                <td>Increased market share</td>
                            </tr>
                            <tr>
                                <td>Faster pace of customer and market change</td>
                                <td>Increase design and engineering productivity</td>
                                <td>Improved perceived services</td>
                            </tr>
                            <tr>
                                <td>Increasing pressure to deliver more value at a lower cost</td>
                                <td>Identify and implement manufacturing efficiencies</td>
                                <td>Improved Go To Market</td>
                            </tr>
                            <tr>
                                <td>Increasing pressure to manage complex supply chain</td>
                                <td>Improve production output and quality</td>
                                <td>Optimise operating cost</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )} />

            <section className="text-left" >
                <Container>
                    <div className="main-title-wrapper text-left">
                    <Col xs={12} lg={{ offset: 6, size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle"
                                Name="Building Blocks"
                                Label=""
                            />

                        <Description
                            Class="site-dec"
                            Name="We realise that all our questions regarding digital transformation are cantered on four building blocks: where your business should be going (digital strategy); how that fits what your business does (business model); what you need to get there (enablers); and how you will manage change to reach your destination (orchestration). With those identified, we took a first step to exploring these further, forming a high-level checklist for digital transformations."
                        />

                    </Col>
                    </div>
                </Container>
            </section>

            <section className="text-left" >
                <Container>
                    <div className="main-title-wrapper text-left">
                    <Col xs={12} lg={{ size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle"
                                Name="Digital strategy"
                                Label=""
                            />

                        <Description
                            Class="site-dec"
                            Name="In our collective experience, setting a digital strategy starts with confronting three key questions: where is my industry headed, what will my company’s role be in that future, and how can I create a path forward that balances a sense of direction with the ability to adapt along the way? Every digital transformation must include elements that pursue business opportunities that are relevant today as well as those that put the organisation on the path towards the future."
                        />

                    </Col>
                    </div>
                </Container>
            </section>

            <section className="text-left">
                <Container>
                    <div className="main-title-wrapper text-left">
                    <Col xs={12} lg={{ offset: 6, size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle"
                                Name="Business model"
                                Label=""
                            />

                        <Description
                            Class="site-dec"
                            Name="Digital transformations are still business transformations, must drive real value for the customer and improved outcomes for the business. These transformations typically result in shifts in the customer experience, digitalisation of products and services, the emergence of new economic models, and advances in operations."
                        />

                    </Col>
                    </div>
                </Container>
            </section>

            <section className="project-wrapper gradient-color text-white">
                <Container>
                    <div className="main-title-wrapper text-left text-white">
                    <Col xs={12} lg={{ size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle text-white"
                                Name="Enablers"
                                Label=""
                            />

                        <Description
                            Class="site-dec text-white"
                            Name="All our digital journeys require change of enablers —data and analytics, IT systems, operating model, people and culture. While digital transformations are obviously about technology, technology often turns out to be relatively easy to get right. We were amazed at how much success really depends on organisation and culture, and how difficult those can be to change. Our greatest challenges lie in hiring new talent, enhancing skills of our own, and shifting our culture to become more innovative and adaptable."
                        />

                    </Col>
                    </div>
                </Container>
            </section>

            <section className="project-wrapper gradient-color text-white">
                <Container>
                    <div className="main-title-wrapper text-left text-white">
                    <Col xs={12} lg={{ offset: 6, size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle text-white"
                                Name="Orchestration"
                                Label=""
                            />

                        <Description
                            Class="site-dec text-white"
                            Name="Leadership has been critical to the success of the transformation journey in the accounts we had worked earlier —communicating priorities, securing funding and overcoming other obstacles. In addition, high-potential leaders from across functions act as digital ambassadors in the orchestration of transformation program. Orchestration would start from gap analysis, proceed on with solution maturing, finalising the priorities, stake holder commitment, delivery organisations ability, steady state takeover, business realisation and sharpening the saw."
                        />

                    </Col>
                    </div>
                </Container>
            </section>

            
            <section className="text-left" >
                <Container>
                    <div className="main-title-wrapper text-left">
                        <Col xs={12} lg={{ size: 6}}>
                            <Titlespan2
                                    Class="sitemain-subtitle"
                                    Name="Services"
                                    Label=""
                                />

                            <Description
                                Class="site-dec"
                                Name="The following are our focused services in Digital Transformation"
                            />

                        </Col>
                        <Col xs={12} lg={12}>
                            <table className="table" style={{ marginTop: '50px'}}>
                                <tbody>
                                    <tr>
                                        <td>Business functions: <br/>marketing, operations, human resources, administration, customer service, etc</td>
                                        <td>Business processes: <br/>connected operations, activities and sets to achieve a specific business goal, business process management, business process optimization and business process automation. Business process optimization is essential in digital transformation strategies and in most industries and cases is a mix of customer-facing goals and internal goals today.</td>
                                        <td>Business models: <br/>businesses function, go-to-market approach and value proposition to the ways it seeks to make money and effectively transforms its core business, tapping into novel revenue sources and approaches</td>
                                    </tr>
                                    <tr>
                                        <td>Business ecosystems:<br/>networks of partners and stakeholders, as well as contextual factors affecting the business such as regulatory or economic priorities and evolutions. New ecosystems are built between companies with the fabric of digital transformation, information, whereby data and actionable intelligence become innovation assets.</td>
                                        <td>Business asset management:<br/>focus on traditional assets, information of business, technological evolutions and of any human relationship and customers. Both customers and information need to be treated as real assets in all perspectives.</td>
                                        <td>Organizational culture: <br/>clear customer-centric, agile and hyper-aware goals achieved by acquiring core competencies across the board in areas such as digital maturity, leadership, knowledge worker silos and enables to be more future-proof. Culture also overlaps with processes, business activities, collaboration and the IT-side of digital transformation.</td>
                                    </tr>
                                    <tr>
                                        <td>Ecosystem and partnership models: <br/>co-operative, collaborative, co-creating and, last but not lost, entirely new business ecosystem approaches, leading to new business models and revenue sources. Ecosystems will be key as-a-service-economy and in achieving digital transformation success.</td>
                                        <td>Customer, Employee, Partner:<br/> Digital transformation puts people and strategy before technology. The changing behaviour, expectations and needs of any stakeholder are crucial. This is expressed in many change subprojects whereby customer-centricity, user experience, worker empowerment, new workplace models, changing channel partner dynamics etc.</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </div>
                </Container>
            </section>
            
            <Project />
        </Layout>
    )
}

export default IndexPage
